import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import PageSEO from '@/components/feature/PageSEO';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '成91官方',
  url: 'https://cheng91.com/',
  description: '成91是备受用户关注的热门平台，本页为您提供成91的官方入口、最新地址、使用教程及常见问题解答。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://cheng91.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '成91官方平台',
  url: 'https://cheng91.com/',
  description: '成91是备受用户关注的热门综合服务平台，致力于为用户提供优质、便捷的在线服务体验。',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'service@cheng91.com',
    contactType: 'customer service',
    availableLanguage: 'Chinese',
  },
};

export default function Home() {
  return (
    <>
      <PageSEO
        title="成91官方落地页 | 成91最新入口与使用指南"
        description="成91是备受用户关注的热门平台，本页为您提供成91的官方入口、最新地址、使用教程及常见问题解答，帮助您快速找到成91并顺畅使用，收藏本页获取成91实时更新信息。"
        keywords="成91,成91官网入口,成91最新地址,成91使用教程,成91官方渠道,成91常见问题,成91会员注册"
      />
      <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <main>
        <HeroSection />
        <FeatureSection />
        <CategorySection />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}